import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default () => {
    gsap.registerPlugin(ScrollTrigger);

    let blockSkills = document.querySelectorAll('.list-skills__item')
    let blockSkillsValue = document.querySelectorAll('.list-skills__value')

    blockSkillsValue.forEach((element, i) => {
        gsap
        .timeline({
            scrollTrigger: {
                trigger: element,
                // toggleActions: animToggleActions,
                start: "top center",
                end: "bottom center",
                // markers: true,
            },
        })
        .from(element, {
            duration: 0.8,
            ease:"none",
            innerHTML:"0",
            roundProps:"innerHTML",
            // textContent: 0,
            // snap: { textContent: 1 },
            // stagger: 10,
        })
    });

    blockSkills.forEach(function(block, i) {

        ScrollTrigger.create({
            // animation: tl,
            trigger: block,
            // markers: true,
            start: "top center",
            end: "bottom center",
            toggleClass: "_active",
        });

    });


    let blockSkillsLast = document.querySelectorAll('.list-skills__item_last');
    let blockSkillsParent = document.querySelector('.list-skills');

    blockSkillsLast.forEach(function(block, i) {
        ScrollTrigger.create({
            trigger: block,
            // markers: true,
            start: "top center-=120px",
            end: "bottom top",
            toggleClass: "_active-last",
            onEnter() {
                blockSkillsParent.classList.add('disable-sticky');
            },
            onLeaveBack() {
                blockSkillsParent.classList.remove('disable-sticky');
            }
        });
    });

    // animation

    const animFadeY = document.querySelectorAll("[data-anim-fadey]");
    const animFadeL = document.querySelectorAll("[data-anim-fadel]");
    const animFadeR = document.querySelectorAll("[data-anim-fader]");
    const animDuration = 0.6;
    const animToggleActions = "play none none none";
    const animStart = "top bottom-=100px";
    const animEnd = "top top";


    animFadeY.forEach((animFY) => {
        gsap
        .timeline({
            scrollTrigger: {
                trigger: animFY,
                toggleActions: animToggleActions,
                start: animStart,
                end: animEnd,
            },
        })
        .fromTo(animFY, {
            y: 70,
            opacity: 0,
        }, {
            y: 0,
            opacity: 1,
            duration: animDuration,
            delay: animFY.dataset.animFadey,
        })
    });

    animFadeL.forEach(e => {
        gsap
        .timeline({
            scrollTrigger: {
                trigger: e,
                toggleActions: animToggleActions,
                start: animStart,
                end: animEnd,
            },
        })
        .fromTo(e, {
            x: -70,
            opacity: 0,
        }, {
            x: 0,
            opacity: 1,
            duration: animDuration,
            delay: e.dataset.animFadel,
        })
    });

    animFadeR.forEach(e => {
        gsap
        .timeline({
            scrollTrigger: {
                trigger: e,
                toggleActions: animToggleActions,
                start: animStart,
                end: animEnd,
            },
        })
        .fromTo(e, {
            x: 70,
            opacity: 0,
        }, {
            x: 0,
            opacity: 1,
            duration: animDuration,
            delay: e.dataset.animFader,
        })
    });

    // anchor
    let faterLnksAnchorMain = document.querySelectorAll('.banner');
    faterLnksAnchorMain.forEach(element => {
        let lnksAnchorMain = element.querySelectorAll('.banner-footer__link');
        for (let i = 0; i < lnksAnchorMain.length; i++) {
            lnksAnchorMain[i].onclick = function(e){
                e.preventDefault();
                // let b = this;
                let el = element.nextElementSibling;
                window.scrollTo({
                    top: el.offsetTop,
                    behavior: "smooth"
                });
            };
        }
    });




}
